import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-action-go.tsx
/**
* icon.24.action.go
*
* Represents the action of "zooming in", "maximizing", "full-screen-ing" an element. For instance used on the full-screen button in presentation mode.
*
* Keywords: arrow, right, forward, navigation, next, direction, movement, pointer
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMTQ2IDcuMTQ2YS41LjUgMCAwIDEgLjcwNyAwbDQgNGEuNS41IDAgMCAxIDAgLjcwOGwtNCA0YS41LjUgMCAwIDEtLjcwNy0uNzA4TDE2LjI5MyAxMkg2LjVhLjUuNSAwIDAgMSAwLTFoOS43OTNsLTMuMTQ2LTMuMTQ2YS41LjUgMCAwIDEgMC0uNzA4IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9928
*/
const Icon24ActionGo = memo(function Icon24ActionGo(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M13.146 7.146a.5.5 0 0 1 .707 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.707-.708L16.293 12H6.5a.5.5 0 0 1 0-1h9.793l-3.146-3.146a.5.5 0 0 1 0-.708",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24ActionGo };

//# sourceMappingURL=icon-24-action-go.js.map